import { Check } from "@frui.ts/bootstrap";
import GeneralSettingCard from "components/GeneralSettingCard";
import type SimplePortalSettings from "entities/simplePortalSettings";
import React from "react";
import styles from "./style.module.scss";

export interface ProviderSettingCardProps {
  translateGeneral: (key: string) => string;
  translate: (key: string) => string;
  updateSettings: () => void;
  loginSettings: { name: string; icon: string; setting?: SimplePortalSettings; description?: string }[];
}

const ProviderSettingCard: React.FunctionComponent<ProviderSettingCardProps> = ({
  translate,
  translateGeneral,
  updateSettings,
  loginSettings,
}) => {
  const checkboxColumn = (setting: SimplePortalSettings | undefined) => {
    if (!setting) {
      return translate("providers_setting.enabled_permanently");
    }

    if (setting.value == "force_disabled") {
      return <span className={styles.danger}>{translate("providers_setting.force_disabled")}</span>;
    }

    return <Check custom target={setting} property="active" label={translateGeneral("active")} id={setting.key} />;
  };

  return (
    <GeneralSettingCard>
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.title}>{translate("providers_setting.title")}</h1>
          <button className="btn btn-success" onClick={updateSettings}>
            {translateGeneral("save_button")}
          </button>
        </div>
        <p className={styles.description}>{translate("providers_setting.description")}</p>
        <table className="table">
          <tbody>
            {loginSettings.map(item => (
              <tr key={`${item.name}-row`}>
                <th>
                  <img className={styles.icon} src={item.icon} />
                  {item.name}
                </th>
                <td>{item.description}</td>
                <td>{checkboxColumn(item.setting)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </GeneralSettingCard>
  );
};

export default ProviderSettingCard;
